
import { getFirestore, collection, addDoc, getDocs, query, orderBy, limit, startAfter } from 'firebase/firestore';
// 追加取得用: lastDoc以降の10件
export async function getMorePostsFromFirestore(lastDoc) {
  const db = getFirestore(getFirebaseApp());
  const postsCollection = collection(db, 'posts');
  const q = query(postsCollection, orderBy('createdAt', 'desc'), startAfter(lastDoc), limit(10));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());
const postsCollection = collection(db, 'posts');

// user: { uid, displayName }
export async function addPostToFirestore(post, user) {
  const docRef = await addDoc(postsCollection, {
    ...post,
    uid: user?.uid || '',
    displayName: user?.displayName || '',
    createdAt: new Date()
  });
  return docRef.id;
}

export async function getPostsFromFirestore() {
  const q = query(postsCollection, orderBy('createdAt', 'desc'), limit(10));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}
